import { getCoreApiV1Useraccess } from 'ApiClient/auth/hooks/UserAccessHooks/useGetCoreApiV1Useraccess'

import { AccessMap } from './authHelper'

const isRoleList = (value: unknown) => Array.isArray(value)

const isAccessMap = (value: unknown): value is AccessMap =>
    !!value &&
    typeof value === 'object' &&
    !Array.isArray(value) &&
    Object.values(value).every(
        (byPublishingHouse) =>
            !!byPublishingHouse &&
            typeof byPublishingHouse === 'object' &&
            !Array.isArray(byPublishingHouse) &&
            Object.values(byPublishingHouse).every(isRoleList),
    )

/**
 * Fetch the user's access map from the identity API — the replacement for the `access` that the
 * legacy implicit flow delivered inside the `opus_user_object` claim.
 *
 * The token is passed explicitly because this runs before the auth query cache is populated, which
 * is where `getHeaders()` would otherwise read it from.
 *
 * `/core/api/v1/useraccess` has no 200 contract in the swagger yet, so the generated response type
 * is `any` — hence the shape check here. Both the bare map and a `{ access }` envelope are accepted;
 * anything else is logged and treated as "no access", which leaves the caller on its existing
 * claim-derived fallback. Swap the guard for the generated type once the backend documents the 200.
 */
export const getUserAccess = async (accessToken: string): Promise<AccessMap | undefined> => {
    try {
        const { data } = await getCoreApiV1Useraccess({
            headers: { Authorization: `Bearer ${accessToken}` },
        })

        if (isAccessMap(data?.access)) return data.access
        if (isAccessMap(data)) return data

        console.warn('[SID] unexpected /useraccess payload, ignoring', data)
        return undefined
    } catch (error) {
        console.warn('[SID] could not fetch user access', error)
        return undefined
    }
}
